import isInteger from 'lodash/isInteger';
import ReactDOM from 'react-dom';

import { usePopperTooltip } from '../Popper';

import styles from './TooltipWrapper.module.scss';

export type TooltipWrapperType = {
  previewMode: any;
  value: JSX.Element;
};

export const TooltipWrapper = (props: TooltipWrapperType) => {
  const { previewMode, value } = props;

  const { getArrowProps, getTooltipProps, setTooltipRef, setTriggerRef, visible } = usePopperTooltip({
    delayHide: 800,
    interactive: true,
    placement: 'left',
    trigger: 'hover',
  });

  if (!previewMode) {
    return ((isInteger(value) ? value.toString() : value) || null) as JSX.Element;
  }

  return (
    <span>
      <div ref={setTriggerRef} className="overflow-value">
        {value}
      </div>

      {visible &&
        ReactDOM.createPortal(
          <div
            ref={setTooltipRef}
            {...getTooltipProps({
              className: 'tooltip-container options-menu-popover',
            })}
          >
            <div className={styles.tooltipWrapper}>{value}</div>
            <div {...getArrowProps({ className: 'tooltip-arrow' })} />
          </div>,
          document.body,
        )}
    </span>
  );
};
